"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  set: function set(style, key, value) {
    style[key] = value;
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/~/material-ui/utils/autoPrefix.js
// module id = 512
// module chunks = 4